import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { environments } from '@/environment';
import { BootService } from '@/services/boot';
import { useClientId } from '@/hooks/client';
import { UpdateClientShippingAddressModal } from '@/types/modal';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore NOTHING I CAN DO
import { AddressForm } from '@vestiaire/vc-address-form';
import { AddressFormModal, ErrorModal } from '@/components/molecules/common/Modal';
import { useQueryClient } from '@tanstack/react-query';
import { QueryKeys } from '@/types/query';

const View: React.FC<{ modal: UpdateClientShippingAddressModal }> = ({ modal }) => {
  const { t } = useTranslation();
  const { onClose, client } = modal;
  const clientIdR = useClientId(Number(client.clientId), false);
  const [isError, setIsError] = useState(false);

  const queryClient = useQueryClient();

  const path = '/adser';
  const adserProps = {
    context: 'ClientAddress',
    modalOpen: false,
    screen: 'default',
    editAddress: {
      clientId: client.clientId,
      country: client.country,
      id: client.clientShippingAddressId,
    },
  };

  useEffect(() => {
    const errorListener = () => {
      setIsError(true);
    };
    const closeListener = () => {
      onClose();
    };
    const addNewAddressListener = () => {
      clientIdR.refetch();
      queryClient.invalidateQueries({ queryKey: [QueryKeys.SHIPPING_FROM_ADDRESS] });
      onClose();
    };
    const selectAddressListener = () => {
      clientIdR.refetch();
      queryClient.invalidateQueries({ queryKey: [QueryKeys.SHIPPING_FROM_ADDRESS] });
      onClose();
    };

    window.removeEventListener('add-new-address', addNewAddressListener);
    window.removeEventListener('closeAdserModal', closeListener);
    window.removeEventListener('adserError', errorListener);
    window.addEventListener('add-new-address', addNewAddressListener);
    window.addEventListener('closeAdserModal', closeListener);
    window.addEventListener('adserError', errorListener);

    return () => {
      window.removeEventListener('add-new-address', addNewAddressListener);
      window.removeEventListener('select-address', selectAddressListener);
      window.removeEventListener('closeAdserModal', closeListener);
      window.removeEventListener('adserError', errorListener);
    };
  }, []);

  try {
    if (isError) {
      return (
        <ErrorModal
          title={t('address_form.title')}
          message={t('service_error.access_denied')}
          onClose={onClose}
          containerStyle={{ minWidth: 400 }}
        />
      );
    }
    return (
      <AddressFormModal
        body={
          <AddressForm
            wcconfig={{
              env: BootService.env,
              lang: 'en',
              parentTool: {
                name: 'C360',
                baseURL: environments[BootService.env].cstBaseUrl + path,
                headers: BootService.getHeaders(),
              },
            }}
            props={adserProps}
          />
        }
        onClose={onClose}
      />
    );
  } catch (error) {
    return (
      <ErrorModal
        title={t('address_form.title')}
        message={t('service_error.general')}
        onClose={onClose}
        containerStyle={{ minWidth: 400 }}
      />
    );
  }
};

export default View;
